/** @format */

import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20">
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <h2 className="text-4xl font-bold">Certifications</h2>
          {/* <p className="text-gray-500">
            Here are some Certifications I have gotten over the years.
          </p> */}
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Certificate of National Service(NYSC)"
            subTitle="October, 2022."
            result="National Youth Service Corp"
            des="Completed the National Youth Service Corp (NYSC) program in October 2022, gaining valuable experience and contributing to national development."
          />
          <ResumeCard
            title="Scrum Fundamentals Certified (SFC)"
            subTitle="November 2022"
            result="SCRUMStudy Accreditation Body for Scrum and Agile"
            des="Attained Scrum Fundamentals Certification (SFC) in November 2022 from SCRUMStudy Accreditation Body, showcasing proficiency in Scrum and Agile methodologies."
          />
          <ResumeCard
            title="Jobberman Soft-Skills"
            subTitle="March 2022"
            result="Jobberman"
            des="Completed the Jobberman Soft-Skills program in March 2022, enhancing interpersonal and professional skills for a well-rounded career."
          />
        </div>
      </div>
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <h2 className="text-4xl font-bold">Fellowships and Programs</h2>
          {/* <p className="text-gray-500">
            Here are some Certifications I have gotten over the years.
          </p> */}
        </div>
        <div className="py-12 mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Astra Fellowship and Leadership Program"
            subTitle="May 2023"
            result="Astra"
            des="Participated in the Astra Fellowship and Leadership Program in May 2023, gaining insights into leadership and entrepreneurship in the software industry."
          />
          <ResumeCard
            title="Andela React Learning Program"
            subTitle="October 2023"
            result="Andela"
            des="Enrolled in the Andela React Learning Program in October 2023, expanding skills and knowledge in React and modern web development practices."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
